import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import HomePage from "./pages/HomePage";
import TestPage from "./pages/TestPage";
import ReaderPage from "./pages/ReaderPage";
import DocumentPage from "./pages/DocumentPage";
import ReadingsPage from "./pages/ReadingsPage";
import BookmarksPage from "./pages/BookmarksPage";
import PremiumPage from "./pages/PremiumPage";
import PremiumSuccessPage from "./pages/PremiumSuccessPage";
import NotificationsPage from "./pages/NotificationsPage";
import NotesPage from "./pages/NotesPage";
import SearchPage from "./pages/SearchPage";
import GardePagesPage from "./pages/GardePagesPage";
import SurlignagesPage from "./pages/SurlignagesPage";
import ModeEmploiPage from "./pages/ModeEmploiPage";
import GuideCommentairesPage from "./pages/GuideCommentairesPage";
import AuthPage from "./pages/AuthPage";
import PrivacyPage from "./pages/PrivacyPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import GravuresToc from "./pages/GravuresToc";
import CartesGeoToc from "./pages/CartesGeoToc";
import HistoireNaturelleToc from "./pages/HistoireNaturelleToc";
import GlossaryPage from "./pages/GlossaryPage";
import Layout from "./components/Layout";
import { OfflineIndicator } from "./components/OfflineIndicator";
import { TooltipProvider } from "./components/ui/tooltip";
import "./App.css";

function App() {
  return (
    <TooltipProvider>
      <BrowserRouter>
        <AuthProvider>
        <Routes>
          <Route path="/connexion" element={<AuthPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/supprimer-compte" element={<DeleteAccountPage />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/test" element={<TestPage />} />
                <Route path="/bible" element={<ReaderPage />} />
                <Route path="/bible/:bookId" element={<ReaderPage />} />
                <Route path="/bible/:bookId/:chapter" element={<ReaderPage />} />
                <Route path="/documents/:section" element={<DocumentPage />} />
                <Route path="/lectures" element={<ReadingsPage />} />
                <Route path="/recherche" element={<SearchPage />} />
                <Route path="/gravures" element={<GravuresToc />} />
                <Route path="/cartes" element={<CartesGeoToc />} />
                <Route path="/histoire-naturelle" element={<HistoireNaturelleToc />} />
                <Route path="/glossaire" element={<GlossaryPage />} />
                <Route path="/garde-pages" element={<GardePagesPage />} />
                <Route path="/surlignages" element={<SurlignagesPage />} />
                <Route path="/signets" element={<BookmarksPage />} />
                <Route path="/notes" element={<NotesPage />} />
                <Route path="/premium" element={<PremiumPage />} />
                <Route path="/premium/success" element={<PremiumSuccessPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/mode-emploi" element={<ModeEmploiPage />} />
                <Route path="/guide-commentaires" element={<GuideCommentairesPage />} />
              </Routes>
            </Layout>
          } />
        </Routes>
        <Toaster position="bottom-center" />
        <OfflineIndicator />
      </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  );
}

export default App;
